import { router } from "@inertiajs/react"
import { CircleAlert } from "lucide-react"
import { useTranslation } from "react-i18next"

import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"

/**
 * OKS-66 — Full-page error state.
 *
 * Renders only when `state === "error"` (controller's `rescue
 * StandardError` branch — service raised and the props all collapsed
 * to nil). UX Spec §3 — Retry button calls `router.reload` with the
 * full prop set so the page refetches end-to-end on click.
 *
 * Uses `text-destructive` per OKS-183 — the `-foreground` variant pairs
 * red on red and is invisible. See `no-destructive-foreground.test.ts`
 * regression guard.
 */
export function AnalyticsErrorState() {
  const { t } = useTranslation()

  return (
    <Card data-testid="admin-analytics-error">
      <CardContent className="flex flex-col items-center justify-center gap-3 py-16 text-center text-sm">
        <CircleAlert className="text-destructive size-10" aria-hidden="true" />
        <p className="text-foreground text-lg font-semibold">
          {t("admin.analytics.error.heading")}
        </p>
        <Button
          type="button"
          variant="outline"
          onClick={() => {
            router.reload({
              only: ["state", "kpis", "overlap", "growth", "top_tenants"],
            })
          }}
          data-testid="admin-analytics-error-retry"
        >
          {t("admin.analytics.error.retry")}
        </Button>
      </CardContent>
    </Card>
  )
}
